import { Link, useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import Layout from '../../components/common/pageLayout'
import './ncr.css'
import constant from '../../constant'
import Header from '../../components/NCR/Detail/header'
import Filter from '../../components/NCR/Detail/filter'
import Comment from '../../components/NCR/Detail/comment'
import Log from '../../components/NCR/Detail/log'
import { useState } from 'react'
import Reply from '../../components/NCR/Detail/reply'
import SendReport from '../../components/NCR/Detail/sendReport'
const Index = () => {

    const location = useLocation();
    const { ncrId, shipId } = location.state;
    const sendMailModalId = `sendMail-ncr-${ncrId || 'default'}`;
    const [selectedComment, setSelectedComment] = useState(null);
    const [activeTab, setActiveTab] = useState('log');
    const [filterPayload, setFilterPayload] = useState({})
    const [contributor, setContributor] = useState([])
    const [ncrDetail, setNcrDetail] = useState(null)
    const [refresh, setRefresh] = useState(false)

    const [statusCount, setStatusCount] = useState([])
    const onChangeFilter = (filterModel) => {
        setFilterPayload(filterModel)
    }
    return (
        <Layout title='NCR'>
            <div className="row">

                <div className="col-lg-12">

                    <div className="card" id={1}>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-12 ">
                                    <Header
                                        refresh={refresh}
                                        setRefresh={setRefresh}
                                        ncrDetail={ncrDetail}
                                    />
                                    <Filter
                                        statusCount={statusCount}
                                        onChangeFilter={onChangeFilter}
                                        contributor={contributor}
                                    />

                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-12 ">
                                    <div className="Plan-details-report">
                                        <div className="row">
                                            <div className="col-md-7">

                                                <div className=" d-flex justify-content-between align-items-center mb-1">
                                                    <h4 className="card-title mb-0">Comments</h4>
                                                    <div>
                                                        <button
                                                            type="button"
                                                            className="btn btn-sm btn-primary me-2"
                                                            style={{
                                                                backgroundImage:
                                                                    "linear-gradient(90deg, rgb(104, 149, 180), rgb(38, 85, 120))"
                                                            }}
                                                            data-bs-toggle="modal"
                                                            data-bs-target={`#${sendMailModalId}`}
                                                        >
                                                            <i className="fas fa-paper-plane label-icon" /> Send Report

                                                        </button>
                                                        <Link
                                                            to={{
                                                                pathname: constant.Authedcomponent.ncrCreateComment.url,
                                                                state: {
                                                                    shipId,
                                                                    ncrId
                                                                }
                                                            }}
                                                            className="btn btn-sm btn-primary me-2"
                                                            style={{
                                                                backgroundImage:
                                                                    "linear-gradient(90deg, rgb(104, 149, 180), rgb(38, 85, 120))"
                                                            }}
                                                        >
                                                            <i className="fa fa-plus-circle label-icon" /> Create comment
                                                        </Link>

                                                    </div>
                                                </div>
                                                <div
                                                    className="modal fade"
                                                    id={sendMailModalId}
                                                    data-bs-backdrop="static"
                                                    data-bs-keyboard="false"
                                                    tabIndex={-1}
                                                    role="dialog"
                                                    aria-labelledby={`${sendMailModalId}Label`}
                                                    aria-hidden="true"
                                                >
                                                    <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                                                        <div className="modal-content">
                                                            <div className="modal-header">
                                                                <h5 className="modal-title" id={`${sendMailModalId}Label`}>
                                                                    Send Report Mail
                                                                </h5>
                                                                <button
                                                                    type="button"
                                                                    className="btn-close"
                                                                    data-bs-dismiss="modal"
                                                                    aria-label="Close"
                                                                />
                                                            </div>
                                                            <div className="modal-body">
                                                                <SendReport
                                                                    key={ncrId || 'ncr-send-report'}
                                                                    data={{
                                                                        ncrId,
                                                                        subject: ncrDetail?.SUBJECT,
                                                                        ncrNumber: ncrDetail?.NCR_NUMBER,
                                                                    }}
                                                                    modalId={sendMailModalId}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <Comment
                                                    setStatusCount={setStatusCount}
                                                    ncrId={ncrId}
                                                    setNcrDetail={setNcrDetail}
                                                    selectComment={setSelectedComment}
                                                    setContributor={setContributor}
                                                    filterPayload={filterPayload}
                                                />

                                            </div>
                                            <div className="col-md-5">

                                                <div className="widget">
                                                    <div className="widget-content">
                                                        <div className="column-wrap">
                                                            <div className="coloumn">

                                                                <div className="activity">
                                                                    <div className="d-flex gap-3 align-items-center mb-3">
                                                                        <h3
                                                                            className={`mb-0 ${activeTab === 'log' ? 'active' : ''}`}
                                                                            onClick={() => setActiveTab('log')}
                                                                        >
                                                                            Activity Log
                                                                        </h3>

                                                                        {selectedComment && (
                                                                            <h3
                                                                                className={`mb-0 ${activeTab === 'replies' ? 'active' : ''}`}
                                                                                onClick={() => setActiveTab('replies')}
                                                                            >
                                                                                Replies
                                                                            </h3>
                                                                        )}
                                                                    </div>
                                                                    {activeTab === 'log' && <Log
                                                                        ncrId={ncrId}

                                                                    />}

                                                                    {activeTab === 'replies' && < Reply
                                                                        ncrId={ncrId}
                                                                        commentId={selectedComment}

                                                                    />}
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </Layout>
    )
}

export default Index
